globalThis.backoffice = globalThis.backoffice || {};

backoffice.formValidator = (function() {
  function formValidator($form, options) {
    this.$form = $form;
    this.options = options || {};
    this.init();
  }

  formValidator.prototype = {
    init: function() {
      var defaults = {
        ignore: ':disabled, :hidden, .select2-search__field',
        errorClass: 'validation-error-label',
        successClass: 'validation-valid-label',
        onkeyup: false,
        async: false,
        highlight: function(element, errorClass) {
          $(element).removeClass(errorClass);
        },
        unhighlight: function(element, errorClass) {
          $(element).removeClass(errorClass);
        },
        errorPlacement: function(error, element) {
          error.insertAfter(element.closest('.form-group').find('label'));
        }
      }

      this.$form.validate($.extend({}, defaults, this.options));

      this.events();
    },
    events: function() {
      var validator = this;

      validator.$form.on('submit', function(e) {
        if($(this).valid()) {
          $(this).submit();
        }

        return false;
      });
    }
  }

  return formValidator;
})();
